import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

/* router-data-store state */
import { RouterDataStoreModule } from './router-data-store/router-data-store.module';
/* settings-data-store state */
import { SettingsDataStoreModule } from './settings-data-store/settings-data-store.module';
/* appointment-data-store state */
import { AppointmentDataStoreModule } from './appointment-data-store/appointment-data-store.module';
/* pharmacy-data-store state */
import { PharmacyDataStoreModule } from './pharmacy-data-store/pharmacy-data-store.module';
/* app-data-store state */
import { AppDataStoreModule } from './app-data-store/app-data-store.module';
/* doctor-data-store state */
import { DoctorDataStoreModule } from './doctor-data-store/doctor-data-store.module';
/* application-data-store state */
import { ApplicationDataStoreModule } from './application-data-store/application-data-store.module';
/* auth-data-store state */
import { AuthDataStoreModule } from './auth-data-store/auth-data-store.module';
/* provider-data-store state */
import { ProviderDataStoreModule } from './provider-data-store/provider-data-store.module';
/* provider-doctor-data-store state */
import { ProviderDoctorDataStoreModule } from './provider-doctor-data-store/provider-doctor-data-store.module';
/* member-data-store state */
import { MemberDataStoreModule } from './member-data-store/member-data-store.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* AppDataStore state */
    AppDataStoreModule,
    /* RouterDataStore state */
    RouterDataStoreModule,
    /* SettingsDataStore state */
    SettingsDataStoreModule,
    /* AppointmentDataStore state */
    AppointmentDataStoreModule,
    /* PharmacyDataStore state */
    PharmacyDataStoreModule,
    /* DoctorDataStore state */
    DoctorDataStoreModule,
    /* ApplicationDataStore state */
    ApplicationDataStoreModule,
    /* AuthDataStore state */
    AuthDataStoreModule,
    /* ProviderDataStore state */
    ProviderDataStoreModule,
    /* ProviderDoctorDataStore state */
    ProviderDoctorDataStoreModule,
    /* MemberDataStore state */
    MemberDataStoreModule,
  ],
  exports: [StoreModule, EffectsModule],
})
export class DataStoresModule { }
